import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UrlService } from '../../services/url.service';

@Component({
  selector: 'app-connection-error-view',
  templateUrl: './connection-error-view.component.html',
  styleUrls: ['./connection-error-view.component.scss'],
  standalone: false
})
export class ConnectionErrorViewComponent {
  constructor(private router: Router, private urlService: UrlService) {}

  reload() {
    const reloadUrl = this.urlService.getUrlBeforeConnectionLost();
    this.router.navigateByUrl(reloadUrl);
  }
}
